<script setup>
import { ref } from "vue";
import { RouterLink } from "vue-router";
import { useScrollStore } from "@/stores/storeScroll";
import TheHeader from "./TheHeader.vue";

const storeScroll = useScrollStore();

defineProps({
	pageLoaded: {
		type: Boolean,
	},
	bgAttachment: {
		type: Boolean,
	},
});
</script>
<template>
	<div :class="['main-screen', { animated: !pageLoaded }]" :style="{ 'padding-top': storeScroll.headerFixed ? `${storeScroll.headerHeight}px` : '', 'background-attachment': bgAttachment ? 'fixed' : '' }">
		<TheHeader :page-loaded />
		<video 
			class="main-screen__video"
			autoplay
			playsinline 
			webkit-playinginline 
			muted
			loop
			width="100%" height="100%" 
			poster="@/assets/img/bg_main.webp"
		>
			<source src="/img/2.mp4" type="video/mp4">
			Ваш браузер не поддерживает встроенные видео
		</video>
		<div class="container">
			<h1 class="title2 main-screen__title">Аренда <span class="title-border">игровых</span> площадок</h1>
			<div class="main-screen__content">
				<p>
					Загородный свежий воздух, упругий звук ударов мяча и азартный смех единомышленников — все это ждет вас на игровых площадках 
					The Rink Fitness в окружении природы. Здесь вы можете устроить увлекательный турнир в падел-теннис, азартные состязания по петанку, 
					семейный матч по настольному теннису или провести стратегические баталии на просторном корте для большого тенниса. Забронируйте любую игровую площадку 
					онлайн и проведите время с удовольствием.
				</p>
				<RouterLink to="/services" class="btn">Забронировать</RouterLink>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped></style>

